import Vue from 'vue';
import Vuex from 'vuex';
import register from './modules/register.store';
import visualResources from './modules/visualResources.store';
import { removeCookieJSON } from '@/utils/cookie';
import { getCookie } from 'tiny-cookie';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    register,
    visualResources,
  },
  state: {},
  mutations: {},
  actions: {
    logout({ commit }) {
      removeCookieJSON('token');
      removeCookieJSON('step');
      removeCookieJSON('payment');
      removeCookieJSON('social');
      commit('register/SET_TOKEN', null, { root: true });
      window.location.href = '/logout';
    },
    appLogout({ commit }) {
      removeCookieJSON('token');
      removeCookieJSON('step');
      removeCookieJSON('payment');
      removeCookieJSON('social');
      commit('register/SET_TOKEN', null, { root: true });
    },
    deleteSessionCookie() {
      removeCookieJSON('AWTOSESSION');
    },
  },
  getters: {
    isAuth(_state, getters) {
      const token = getters['register/userToken'];
      if (getCookie('AWTOSESSION') || token) {
        return true;
      }
      return false;
    },
  },
});
